import React, { useCallback, useEffect, useState } from "react";
import { decideProfileChangeRequest, fetchPendingProfileChangeRequests } from "../api/client";

export default function ProfileChangeRequests() {
  const [requests, setRequests] = useState([]);
  const [busyId, setBusyId] = useState("");
  const [error, setError] = useState("");
  const refresh = useCallback(async () => {
    try { setRequests(await fetchPendingProfileChangeRequests()); setError(""); }
    catch (err) { setError(err.message || "Profile change requests are unavailable."); }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const decide = async (item, decision) => {
    setBusyId(item.request_id);
    try { await decideProfileChangeRequest(item.request_id, decision); await refresh(); }
    catch (err) { setError(err.message || "Decision could not be recorded."); }
    finally { setBusyId(""); }
  };
  return <section className="studio-panel iam-pending-panel" aria-label="Profile change requests">
    <div className="studio-panel-header"><h2>Profile change requests ({requests.length})</h2>
      <button className="studio-btn-ghost" type="button" onClick={refresh}>Refresh</button></div>
    <p className="studio-muted">Administrator approval authorizes the account change; it does not verify mailbox ownership.</p>
    {error && <p className="studio-alert studio-alert-attention" role="alert">{error}</p>}
    {!requests.length && !error && <p className="studio-muted">No profile changes awaiting review.</p>}
    {requests.map(item => <article className="iam-pending-row" key={item.request_id}>
      <div><strong>{item.display_name || item.login}</strong>
        <div className="studio-muted">{item.login} · {item.change_type.replaceAll("_", " ")}</div>
        {item.proposed_email && <div>{item.proposed_email}</div>}
        <div className="studio-muted">{new Date(item.requested_at).toLocaleString()}</div></div>
      <div className="iam-pending-actions">
        <button className="studio-btn-primary" type="button" disabled={!!busyId} onClick={() => decide(item, "APPROVE")}>Approve</button>
        <button className="studio-btn-ghost" type="button" disabled={!!busyId} onClick={() => decide(item, "REJECT")}>Reject</button>
      </div>
    </article>)}
  </section>;
}
